// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1fKgj","heading":"Header_heading__2b8Qj","avatar":"Header_avatar__3qaq8"};